import {
  Resourcesxj47ux575wgw as Resources,
  Configuration2nkvs43ewppzi as Configuration,
} from './ktor-ktor-resources.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  protoOf180f3jzyo7rfj as protoOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
import {
  TypeInfo2nbxsuf4v8os2 as TypeInfo,
  AttributeKey3aq8ytwgx54f7 as AttributeKey,
} from './ktor-ktor-utils.mjs';
import { pluginOrNulleoo3166jvfvu as pluginOrNull } from './ktor-ktor-client-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForObject(Resources_0, 'Resources');
//endregion
function Resources_0() {
  Resources_instance = this;
  var tmp = this;
  // Inline function 'io.ktor.util.AttributeKey' call
  var name = 'Resources';
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = getKClass(Resources);
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(getKClass(Resources), arrayOf([]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$0 = tmp_1;
  var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$0);
  tmp.s60_1 = new AttributeKey(name, tmp$ret$1);
}
protoOf(Resources_0).v = function () {
  return this.s60_1;
};
protoOf(Resources_0).t60 = function (block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new Configuration();
  block(this_0);
  var config = this_0;
  return new Resources(config);
};
protoOf(Resources_0).i4r = function (block) {
  return this.t60(block);
};
protoOf(Resources_0).u60 = function (plugin, scope) {
};
protoOf(Resources_0).j4r = function (plugin, scope) {
  return this.u60(plugin instanceof Resources ? plugin : THROW_CCE(), scope);
};
var Resources_instance;
function Resources_getInstance() {
  if (Resources_instance == null)
    new Resources_0();
  return Resources_instance;
}
function resources(_this__u8e3s4) {
  var tmp0_elvis_lhs = pluginOrNull(_this__u8e3s4, Resources_getInstance());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('Resources plugin is not installed');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
//region block: exports
export {
  Resources_getInstance as Resources_getInstance1cm9gq33f51s4,
  resources as resources3ic0fpytzdw80,
};
//endregion

//# sourceMappingURL=ktor-ktor-client-resources.mjs.map
